import { createContext } from "react";

const assessmentContext = createContext();

export default assessmentContext;
